import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const TransactionStatusPendingIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM9.23828 3.98926C9.03954 3.99236 8.85016 4.07423 8.71173 4.21686C8.5733 4.3595 8.49715 4.55125 8.5 4.75V10.25C8.50004 10.4489 8.57907 10.6396 8.71973 10.7803L11.2197 13.2803C11.2888 13.3523 11.3716 13.4097 11.4632 13.4493C11.5548 13.4889 11.6534 13.5098 11.7532 13.5108C11.8529 13.5118 11.9519 13.4929 12.0443 13.4552C12.1367 13.4175 12.2206 13.3617 12.2912 13.2912C12.3617 13.2206 12.4175 13.1367 12.4552 13.0443C12.4929 12.9519 12.5118 12.8529 12.5108 12.7532C12.5098 12.6534 12.4889 12.5548 12.4493 12.4632C12.4097 12.3716 12.3523 12.2888 12.2803 12.2197L10 9.93945V4.75C10.0014 4.64962 9.98271 4.54997 9.94493 4.45695C9.90715 4.36394 9.85108 4.27946 9.78004 4.20852C9.70901 4.13758 9.62446 4.08161 9.5314 4.04395C9.43834 4.00629 9.33866 3.98769 9.23828 3.98926Z"
        fill="#F1D07A"
      />
    </CustomSvg>
  );
};
export default TransactionStatusPendingIcon;
